// Natural casino roulette spin audio, generated with WebAudio (no assets).
// playRouletteSpin: decelerating fret ticks + low whoosh while the wheel spins.
// playLandSound: landing clacks with diminishing bounces — call it exactly when
// the ball visually lands so audio and animation stay in sync.

let sharedCtx = null;
function getCtx() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  if (!sharedCtx || sharedCtx.state === "closed") sharedCtx = new Ctx();
  if (sharedCtx.state === "suspended") sharedCtx.resume().catch(() => {});
  return sharedCtx;
}

function makeClick(ctx) {
  const buf = ctx.createBuffer(1, Math.floor(ctx.sampleRate * 0.03), ctx.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * Math.exp(-i / (d.length * 0.22));
  return (t, gain, rate) => {
    const src = ctx.createBufferSource();
    src.buffer = buf;
    src.playbackRate.value = rate;
    const f = ctx.createBiquadFilter();
    f.type = "bandpass"; f.frequency.value = 2500; f.Q.value = 1.1;
    const g = ctx.createGain();
    g.gain.value = gain;
    src.connect(f); f.connect(g); g.connect(ctx.destination);
    src.start(t);
  };
}

// Must be called synchronously inside the click handler (before any await):
// browsers only unlock audio during a user gesture. Plays one silent sample
// to fully unlock WebAudio on iOS/Android.
export function unlockAudio() {
  try {
    const ctx = getCtx();
    if (!ctx) return;
    const b = ctx.createBuffer(1, 1, 22050);
    const s = ctx.createBufferSource();
    s.buffer = b;
    s.connect(ctx.destination);
    s.start(0);
  } catch { /* ignore */ }
}

export function playRouletteSpin(durationMs) {
  try {
    const ctx = getCtx();
    if (!ctx) return;
    const t0 = ctx.currentTime;
    const dur = durationMs / 1000;
    const click = makeClick(ctx);

    // decelerating ticks — ball passing the frets, fading out near the stop
    let t = 0.05, interval = 0.045;
    while (t < dur - 0.15) {
      const fade = t > dur - 1 ? Math.max(0.25, (dur - t)) : 1;
      click(t0 + t, 0.085 * fade, 1 + Math.random() * 0.18);
      interval *= 1.055;
      t += interval;
    }

    // low mechanical whoosh fading with the wheel
    const nBuf = ctx.createBuffer(1, Math.floor(ctx.sampleRate * dur), ctx.sampleRate);
    const nd = nBuf.getChannelData(0);
    for (let i = 0; i < nd.length; i++) nd[i] = Math.random() * 2 - 1;
    const ns = ctx.createBufferSource();
    ns.buffer = nBuf;
    const nf = ctx.createBiquadFilter();
    nf.type = "lowpass";
    nf.frequency.setValueAtTime(850, t0);
    nf.frequency.exponentialRampToValueAtTime(160, t0 + dur);
    const ng = ctx.createGain();
    ng.gain.setValueAtTime(0.05, t0);
    ng.gain.exponentialRampToValueAtTime(0.005, t0 + dur);
    ns.connect(nf); nf.connect(ng); ng.connect(ctx.destination);
    ns.start(t0); ns.stop(t0 + dur);
  } catch { /* audio unavailable — spin continues silently */ }
}

// Big "handful of coins tumbling onto a hard floor" sound — many metallic
// clinks that each bounce a few times and settle, generated with WebAudio (no
// assets). Call this the moment a WIN is revealed in any casino game.

// One metallic clink: inharmonic square partials (metal timbre) + a short hard
// noise transient (the coin striking the floor).
function metalTick(ctx, t, freq, gain, dur) {
  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.linearRampToValueAtTime(gain, t + 0.0015);
  g.gain.exponentialRampToValueAtTime(0.0004, t + dur);
  g.connect(ctx.destination);
  [1, 2.76].forEach((p, i) => {
    const o = ctx.createOscillator();
    o.type = "square";
    o.frequency.value = freq * p;
    const pg = ctx.createGain();
    pg.gain.value = 1 / (i + 1.6);
    o.connect(pg); pg.connect(g);
    o.start(t); o.stop(t + dur);
  });
  // hard-floor impact transient
  const nb = ctx.createBuffer(1, Math.floor(ctx.sampleRate * 0.018), ctx.sampleRate);
  const nd = nb.getChannelData(0);
  for (let i = 0; i < nd.length; i++) nd[i] = (Math.random() * 2 - 1) * Math.exp(-i / (nd.length * 0.22));
  const ns = ctx.createBufferSource(); ns.buffer = nb;
  const bp = ctx.createBiquadFilter(); bp.type = "bandpass"; bp.frequency.value = freq * 1.4; bp.Q.value = 1.1;
  const ng = ctx.createGain(); ng.gain.value = gain * 0.55;
  ns.connect(bp); bp.connect(ng); ng.connect(ctx.destination);
  ns.start(t);
}

// One coin falling: an impact plus 2–4 diminishing, accelerating bounces.
function coinFall(ctx, t, freq, gain) {
  let tt = t, g = gain, gap = 0.05 + Math.random() * 0.04;
  const bounces = 1 + Math.floor(Math.random() * 2);
  for (let b = 0; b <= bounces; b++) {
    metalTick(ctx, tt, freq * (1 + b * 0.012), g, 0.08 - b * 0.011);
    g *= 0.55;
    gap *= 0.72;   // bounces get closer together
    tt += gap;
  }
}

// A coin spinning flat to rest — accelerating chatter that dies out (the classic
// "coin settling" signature).
function coinSettle(ctx, t, freq) {
  let tt = t, gap = 0.06, g = 0.05;
  for (let i = 0; i < 6; i++) {
    metalTick(ctx, tt, freq, g, 0.03);
    gap *= 0.86;   // accelerate
    g *= 0.9;
    tt += gap;
  }
}

// A bright bell/chime note (musical, triumphant) — two detuned partials + fast decay.
function bellNote(ctx, t, freq, gain, dur = 0.55) {
  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.linearRampToValueAtTime(gain, t + 0.008);
  g.gain.exponentialRampToValueAtTime(0.0005, t + dur);
  g.connect(ctx.destination);
  [[1, "triangle"], [2.0, "sine"], [3.0, "sine"]].forEach(([mult, type], i) => {
    const o = ctx.createOscillator();
    o.type = type;
    o.frequency.value = freq * mult;
    const pg = ctx.createGain();
    pg.gain.value = [1, 0.35, 0.18][i];
    o.connect(pg); pg.connect(g);
    o.start(t); o.stop(t + dur);
  });
}

// Rising anticipation sweep (the "here comes a win" whoosh up).
function riser(ctx, t, dur = 0.4) {
  const o = ctx.createOscillator();
  o.type = "sawtooth";
  o.frequency.setValueAtTime(220, t);
  o.frequency.exponentialRampToValueAtTime(1400, t + dur);
  const bp = ctx.createBiquadFilter();
  bp.type = "lowpass";
  bp.frequency.setValueAtTime(600, t);
  bp.frequency.exponentialRampToValueAtTime(4000, t + dur);
  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.linearRampToValueAtTime(0.10, t + dur * 0.8);
  g.gain.exponentialRampToValueAtTime(0.0005, t + dur + 0.05);
  o.connect(bp); bp.connect(g); g.connect(ctx.destination);
  o.start(t); o.stop(t + dur + 0.05);
}

export function playCoinSplash() {
  try {
    const ctx = getCtx();
    if (!ctx) return;
    const t0 = ctx.currentTime;

    // 1) Anticipation riser leading into the hit.
    riser(ctx, t0, 0.35);

    // 2) Triumphant major-chord arpeggio "WIN!" sting (C major up: C5 E5 G5 C6),
    //    notes staggered so it sparkles upward, then a bright top shimmer.
    const chord = [523.25, 659.25, 783.99, 1046.5];
    chord.forEach((f, i) => bellNote(ctx, t0 + 0.30 + i * 0.06, f, 0.16, 0.7));
    bellNote(ctx, t0 + 0.30, 1046.5, 0.10, 0.9);   // sustained top note for body
    bellNote(ctx, t0 + 0.62, 1567.98, 0.12, 0.6);  // G6 sparkle accent

    // 3) Sparkle wash (bright filtered-noise shimmer) under the chord.
    const sdur = 0.7;
    const sb = ctx.createBuffer(1, Math.floor(ctx.sampleRate * sdur), ctx.sampleRate);
    const sd = sb.getChannelData(0);
    for (let i = 0; i < sd.length; i++) sd[i] = (Math.random() * 2 - 1) * Math.exp(-i / (sd.length * 0.4));
    const ss = ctx.createBufferSource(); ss.buffer = sb;
    const hp = ctx.createBiquadFilter(); hp.type = "highpass"; hp.frequency.value = 6000;
    const sg = ctx.createGain();
    sg.gain.setValueAtTime(0.07, t0 + 0.3);
    sg.gain.exponentialRampToValueAtTime(0.003, t0 + 0.3 + sdur);
    ss.connect(hp); hp.connect(sg); sg.connect(ctx.destination);
    ss.start(t0 + 0.3); ss.stop(t0 + 0.3 + sdur);

    // 4) Coin payout cascade (arrives with the chord) — the "money pouring in"
    //    feel. Kept lean (fewer coins/bounces) so the win never hitches the UI.
    const N = 10;
    for (let i = 0; i < N; i++) {
      const t = t0 + 0.32 + Math.pow(i / N, 1.5) * 1.15 + Math.random() * 0.03;
      const freq = 1800 + Math.random() * 4200;
      const gain = 0.12 * (1 - (i / N) * 0.5);
      coinFall(ctx, t, freq, gain);
    }
    // A coin spins to rest as the pile settles.
    coinSettle(ctx, t0 + 1.15, 3200 + Math.random() * 1400);
  } catch { /* audio unavailable — win still shows */ }
}
